// import React, { useRef } from 'react';
import './Career.css';
import { Helmet } from "react-helmet-async";
const reasonsToJoin = [
    "Work with a passionate and skilled team",
    "Opportunity to grow in a fast-paced tech environment",
    "Work-life balance and hybrid options",
    "Real impact on products and services",
    "Transparent and inclusive work culture",
    "Access to the latest tools and technologies",
    "Mentorship from industry experts",
    "Freedom to innovate and experiment",
    "Flat hierarchy and open communication",
    "Global client exposure and projects",
    "Regular team outings and virtual fun sessions",
    "Performance recognition and rewards"
];

// const openings = [
//     {
//         title: "Frontend Developer (React)",
//         location: "Remote / Bangalore",
//         type: "Full-Time",
//         experience: "2+ years",
//     },
//     {
//         title: "Backend Developer (Node.js)",
//         location: "Remote / Hyderabad",
//         type: "Full-Time",
//         experience: "3+ years",
//     },
//     {
//         title: "UI/UX Designer",
//         location: "On-Site / Delhi",
//         type: "Part-Time",
//         experience: "1+ years",
//     },
//     {
//         title: "Sales & Marketing Executive",
//         location: "Remote / Mumbai",
//         type: "Full-Time",
//         experience: "2+ years",
//     },
//     {
//         title: "Mobile App Developer (Flutter)",
//         location: "Remote / Pune",
//         type: "Full-Time",
//         experience: "2+ years",
//     },
//     {
//         title: "Content Writer (IT/Tech)",
//         location: "Remote",
//         type: "Freelance",
//         experience: "1+ years",
//     },
//     {
//         title: "Web Development Intern (Paid)",
//         location: "Remote / On-site",
//         type: "Internship",
//         experience: "Fresher / Student",
//     },
//     {
//         title: "Marketing Intern (Unpaid)",
//         location: "Remote",
//         type: "Internship",
//         experience: "Fresher / Student",
//     },
// ];

// const benefits = [
//     "Flexible work hours",
//     "Friendly team culture",
//     "Career growth opportunities",
//     "Paid time off & holidays",
//     "Learning & development budget",
//     "Performance-based bonuses",
//     "Work from home options",
//     "Health and wellness programs",
//     "Employee recognition awards",
//     "Access to latest tools and technologies"
// ];

const Career = () => {
    // const formRef = useRef(null);

    // const handleApplyClick = () => {
    //     formRef.current?.scrollIntoView({ behavior: 'smooth' });
    // };

    return (
        <div className="career-container">

           <Helmet>
  <title>Careers  | Join Our IT Team</title>
  <meta 
    name="description" 
    content="Looking for IT jobs in Ankleshwar? Explore exciting career opportunities at APTech Solution in web development, app development, Salesforce, and digital marketing." 
  />
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        "title": "Software Developer / Web Developer / App Developer",
        "description": "Join APTech Solution’s IT team in Ankleshwar. We are hiring for roles in web development, app development, Salesforce, and digital marketing.",
        "hiringOrganization": {
          "@type": "Organization",
          "name": "APTech Solution",
          "sameAs": "https://aptechsolution.com",
          "logo": "https://aptechsolution.com/logo.png"
        },
        "jobLocation": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Ankleshwar",
            "addressRegion": "Gujarat",
            "addressCountry": "India"
          }
        }
      }
    `}
  </script>
</Helmet>


            <h1 className="career-title">Join Our Team</h1>
            <p className="career-subtitle">
                We’re looking for passionate people to help us build innovative digital solutions.
                Explore our open roles and become part of our journey.
            </p>

            {/* <section className="culture-section">
                <h2 className="section-heading">Life at Our Company</h2>
                <p className="culture-text">
                    We believe in innovation, collaboration, and growth. Our team works hard, supports each other, and enjoys the ride together.
                </p>
                <div className="culture-gallery">
                    <img src="/images/team1.jpg" alt="Team" />
                    <img src="/images/team2.jpg" alt="Office" />
                    <img src="/images/event.jpg" alt="Event" />
                </div>
            </section> */}

            <section className="career-section">
                <h2 className="section-heading">Why Work With Us?</h2>
                <div className="reason-grid">
                    {reasonsToJoin.map((reason, idx) => (
                        <div className="reason-card bottom-border-card" key={idx}>
                            <span className="card-icon">🌟</span>
                            <p>{reason}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* <section className="career-section">
                <h2 className="section-heading">Current Openings</h2>
                <div className="job-list">
                    {openings.map((job, idx) => (
                        <div className="job-card gradient-border-card" key={idx}>
                            <h3>{job.title}</h3>
                            {job.type === "Internship" && (
                                <span className="intern-badge">🎓 Internship</span>
                            )}
                            <div className="job-meta">
                                <span>📍 {job.location}</span>
                                <span>🕒 {job.type}</span>
                                <span>💼 {job.experience}</span>
                            </div>
                            <button
                                className="apply-button"
                                onClick={handleApplyClick}
                            >
                                Apply Now
                            </button>
                        </div>
                    ))}
                </div>
            </section> */}


            {/* <section className="career-section apply-form-section" ref={formRef}>
                <h2 className="section-heading">Apply Now</h2>
                <form className="apply-form">
                    <input type="text" placeholder="Full Name" required />
                    <input type="email" placeholder="Email Address" required />
                    <input type="text" placeholder="Position Interested In" required />
                    <input type="file" accept=".pdf,.doc,.docx" />
                    <textarea placeholder="Cover Letter (optional)"></textarea>
                    <button type="submit">Submit Application</button>
                </form>
            </section> */}

            {/* <section className="cta-box animated">
                <h3>Didn't find a role that fits?</h3>
                <p>We’re always on the lookout for great talent. Send your resume to <strong>careers@example.com</strong></p>
                <button className="cta-button">Send Resume</button>
            </section> */}




            <section className="career-section2">
                <h2 className="section-heading">Current Openings</h2>
                <div className="Notjob">

                    <div>There are no current openings. When they come, they will be posted here.  </div>
                </div>
            </section>

            <section className="cta-box animated">
                <h3>No current openings? You can still apply!</h3>
                <p>We’re always on the lookout for great talent. Send your resume to <strong>hr@aptechsolution.com</strong></p>
                <a href="mailto:hr@aptechsolution.com" target="_blank" rel="noopener noreferrer">
                    <button className="cta-button">Send Resume</button>
                </a>

              
            </section>


                 



        </div>
    );
};

export default Career;
